import { Component, OnInit } from '@angular/core';
import { InputWidget } from '../input-widget';

@Component({
  selector: 'app-yesno',
  templateUrl: './yesno.component.html',
  styleUrls: ['./yesno.component.scss'],
})
export class YesNoComponent extends InputWidget {

  static componentName = 'YesNoComponent';

  constructor() {
    super();    
    this.validateYesNoControl =this.validateYesNoControl.bind(this);
  }

  validateYesNoControl()
  {        
    if (this._value==true || this._value==false)
      return null;
    else
    {
      if (this.required==true)
        return {required:true};
      else
        return null;
    }
  }

  getValue() {    
    return String(this._value);
  }

  isValid() {                
    return (this.validateYesNoControl()==null);
  }

  setValue(val) {
    if (typeof val === 'string'){
      val = val.toLowerCase();
      if ((val === 'true') || (val==='yes'))
        this._value = true;
      else if ((val === 'false') || (val==='no'))
        this._value = false;
      else
        this._value = undefined;
    }
    else{
      this._value = val;
    }    
  }
}
